/** @jsx jsx */
import { jsx } from "@emotion/core"

import { Grid } from "@cd2/components"
import { P, TextBlock } from "@cd2/text"
import {
  calculateMarginFromPrice,
  DISCOUNT_COLUMN_WIDTH,
  IQuoteOrderRecord,
  isDeleted,
  itemTypes,
  MARGIN_COLUMN_WIDTH,
  PRICE_COLUMN_WIDTH,
  QUANTITY_COLUMN_WIDTH,
  totalDiscount,
  totalPrice,
} from "./quoteOrderUtils"
import { useSettings } from "../../utils/useSettings"
import { formatPrice } from "../../utils/utils"
import { getCurrencyOption } from "../../utils/currency"
import { useGlobalState } from "../../Components/GlobalStateProvider"

interface ITotalsRowProps {
  quote: IQuoteOrderRecord
  isCustomerViewing?: boolean
}

export function TotalsRow({ quote, isCustomerViewing }: ITotalsRowProps) {
  const { currentUser } = useGlobalState()
  const { showDiscountOption } = useSettings()
  const items = quote.items.filter(item => !isDeleted(item) && item.type !== itemTypes.buildSetItem)

  const discountAmount = totalDiscount(items, "price_pennies")
  const costOfGoods = totalPrice(items, "cost_price_pennies")
  const totalQuotedCost = totalPrice(items, "price_pennies")
  const margin = calculateMarginFromPrice(costOfGoods, totalQuotedCost - discountAmount)
  const currency =
    getCurrencyOption(quote?.currency_name || currentUser?.branch.currency_name || "pound sterling")
      ?.symbol ?? ""

  return (
    <TextBlock size="small" color="#888">
      <Grid
        alignItems="end"
        columns={
          [
            "auto",
            150,
            QUANTITY_COLUMN_WIDTH,
            showDiscountOption && DISCOUNT_COLUMN_WIDTH,
            !isCustomerViewing && PRICE_COLUMN_WIDTH,
            PRICE_COLUMN_WIDTH,
            !isCustomerViewing && MARGIN_COLUMN_WIDTH,
          ].filter(Boolean) as number[]
        }
      >
        <div />
        <div />
        <div>
          <b>Totals</b>
        </div>
        {showDiscountOption && (
          <div>
            <P>Total discount</P>
            {formatPrice(discountAmount, { isPennies: true, currency })}
          </div>
        )}
        {!isCustomerViewing && (
          <div>
            <P>Cost of goods</P>
            {formatPrice(costOfGoods, { isPennies: true, currency })}
          </div>
        )}
        <div>
          <P>Total quoted cost</P>
          {formatPrice(totalQuotedCost, { isPennies: true, currency })}
        </div>
        {!isCustomerViewing && (
          <div>
            <P>Margin</P>
            {margin.toFixed(2)}%
          </div>
        )}
      </Grid>
    </TextBlock>
  )
}
